module.exports = __webpack_public_path__ + "static/media/location_vector_orange.6f795bd2.svg";